import React from 'react'
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

export default function AlertSnackbar(props) {

    const { notify, setNotify } = props;

    if (!notify.hideDuration) {
        notify.hideDuration = 1000;
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setNotify({
            ...notify,
            isOpen: false
        })
    }

    return (
        <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={notify.isOpen}
            onClose={handleClose}
            key={'topcenter'}
            autoHideDuration={notify.severity === 'error' ? 5000 : notify.hideDuration}
        >
            <Alert onClose={handleClose} severity={notify.severity} sx={{ width: '100%' }}>
                {notify.alertTitle && <AlertTitle>{notify.alertTitle}</AlertTitle>}
                <span style={{ whiteSpace: 'pre-line' }}>{notify.message}</span>
            </Alert>
        </Snackbar>
    )
}